import { onSnapshot } from 'mobx-state-tree'

import BookExperienceStore from './BookExperienceStore'
import CategoriesStore from './CategoriesStore'
import CitiesStore from './CitiesStore'
import CreateExperienceStore from './CreateExperienceStore'
import ExperiencesStore from './ExperiencesStore'
import ExperiencesSearchStore from './ExperiencesSearchStore'
import ModalsStore from './ModalsStore'
import MyBookingsStore from './MyBookingsStore'
import MyExperiencesStore from './MyExperiencesStore'
import PaymentMethodsStore from './PaymentMethodsStore'
import RateExperienceStore from './RateExperienceStore'
import UserStore from './UserStore'
import UserByIdStore from './UserByIdStore'
import WishlistStore from './WishlistStore'
import NotificationsStore from './NotificationsStore'

// Load user from LocalStorage and fix for missing user on page reload
const STORAGE_USER_KEY = 'UserStore'
const storageUser = localStorage.getItem(STORAGE_USER_KEY)
const initialStateUser = storageUser
  ? JSON.parse(storageUser)
  : {}
const userStore = UserStore.create(initialStateUser)

onSnapshot(userStore, (snapshot) => {
  console.log('snapshot', snapshot)
  localStorage.setItem(STORAGE_USER_KEY, JSON.stringify(snapshot))
})

/**
 * Store
 * @description `@type` used for speedup JetBrains IDE
 * @type {Object|*|any}
 */
const store = {
  book_experience_store: BookExperienceStore.create(),
  categories: CategoriesStore.create(),
  cities: CitiesStore.create(),
  create_experience: CreateExperienceStore.create(),
  experiences: ExperiencesStore.create(),
  experiencesSearch: ExperiencesSearchStore.create(),
  modals: ModalsStore.create(),
  my_bookings: MyBookingsStore.create(),
  my_experiences: MyExperiencesStore.create(),
  payment_methods: PaymentMethodsStore.create(),
  rate_experience_store: RateExperienceStore.create(),
  user: userStore,
  userById: UserByIdStore.create(),
  wishlist: WishlistStore.create(),
  notifications: NotificationsStore.create()
}

export default store


// WEBPACK FOOTER //
// ./src/stores/index.js